import { useQuery } from '@tanstack/react-query'
import type { UseQueryOptions } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { AdminKycVerificationSchema } from '../model/kyc-verification'
import type { AdminKycVerification } from '../model/kyc-verification'

export const adminKycVerificationKey = (userId: string | null) =>
  ['admin-kyc-verification', userId] as const

export function useAdminKycVerification(
  userId: string | null,
  enabled = true,
  options: Pick<UseQueryOptions<AdminKycVerification>, 'refetchInterval'> = {},
) {
  return useQuery({
    queryKey: adminKycVerificationKey(userId),
    queryFn: async () =>
      AdminKycVerificationSchema.parse(
        await apiFetch<unknown>(`/admin/users/${encodeURIComponent(userId!)}/kyc/verification`, {
          cache: 'no-store',
        }),
      ),
    enabled: enabled && Boolean(userId),
    gcTime: 0,
    ...options,
  })
}
